import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Leaf } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setAuthState } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setError("Missing session_id");
      setTimeout(() => nav("/login"), 1500);
      return;
    }
    const sessionId = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { session_id: sessionId });
        // Store token same as regular login flow
        localStorage.setItem("cl_token", data.token);
        if (setAuthState) setAuthState({ user: { id: data.id, email: data.email, name: data.name }, token: data.token });
        // Clear URL fragment
        window.history.replaceState(null, "", window.location.pathname);
        nav("/app");
      } catch (e) {
        setError(e.response?.data?.detail || "Google authentication failed");
        setTimeout(() => nav("/login"), 2000);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-3">
        <div className="w-12 h-12 mx-auto rounded-md bg-primary text-primary-foreground flex items-center justify-center animate-pulse">
          <Leaf size={24} weight="fill" />
        </div>
        <div className="font-display text-lg">
          {error ? error : "Enasuspro® hesabınıza giriş yapılıyor…"}
        </div>
        {!error && <div className="text-xs text-muted-foreground font-mono-data">Bir saniye…</div>}
      </div>
    </div>
  );
}
